@if (isMainMenuItemVisible) {
@if (theOnlySubMenuItem) {
<div [ngClass]="{ 'active-menu-item': isActiveRoute }" style="padding: 6px 0;">
    <button (click)="navigateMainMenu()" [ngClass]="{ 'active-route': isActiveRoute }" aria-label="Main Menu Item"
        mat-icon-button routerLinkActive="active-route"
        [matTooltip]="isMenuNameVisible ? '' : theOnlySubMenuItem?.displayName" matTooltipPosition="right">
        <mat-icon [ngStyle]="{transform: 'scale(' + (isMenuNameVisible ? '.8' : '1.2') + ')'}">{{
            theOnlySubMenuItem?.iconName }}
        </mat-icon>
    </button>
    @if (isMenuNameVisible) {
    <br />
    <span style="font-size: 0.7em">{{ theOnlySubMenuItem?.displayName }}</span>
    }
</div>
} @else {
<div [ngClass]="{ 'active-menu-item': isActiveRoute }" style="padding: 6px 0;">
    <button [matMenuTriggerFor]="menu" [ngClass]="{ 'active-route': isActiveRoute }" aria-label="Main Menu Item"
        mat-icon-button routerLinkActive="active-route" [matTooltip]="isMenuNameVisible ? '' : mmi?.displayName"
        matTooltipPosition="right">
        <mat-icon [ngStyle]="{transform: 'scale(' + (isMenuNameVisible ? '.8' : '1.2') + ')'}">{{ mmi.iconName }}
        </mat-icon>
    </button>
    @if (isMenuNameVisible) {
    <br />
    <span style="font-size: 0.7em">{{ mmi.displayName }}</span>
    }

    <mat-menu #menu="matMenu">
        @for (sm of mmi.subMenuItems; track sm) {
        @if (submenuItemPermissionMap[sm.uuid]) {
        <button (click)="navigateSubMenu(sm)" mat-menu-item routerLinkActive="active-route">
            <mat-icon>{{
                sm.iconName ? sm.iconName : mmi.iconName
                }}
            </mat-icon>

            <span [ngStyle]="{ 'font-weight': sm.bold === true ? 'bold' : 'normal' }">{{
                sm.displayName
                }}</span>
        </button>
        }
        }
    </mat-menu>
</div>
}
}